import { IModel } from '@src/js/separate-logic/interface/IModel';
import EffectFilter from '../effects-filter';
import ImageFilter from '../images-filter';
import StrokeInfo from './bg-shapes/stroke-info/index';
import FillBackground from '../fill-background/index';
import { createGraphicsParser, GraphicsType } from '@tencent/alloy-graphics';

export default class GraphicContentModel implements IModel {
    private effectFilter;
    private imageFilter;
    private fillBackground: FillBackground;
    private strokeInfo: StrokeInfo;
    private pathParser;

    public initModel(props) {
        this.pathParser = createGraphicsParser({
            type: props.model.bgShape ?? GraphicsType.RECT,
            controlValues: props.model.controlValues,
            width: props.model.width,
            height: props.model.height,
            pathList: props.model.pathList,
        });

        this.strokeInfo = new StrokeInfo(props.minStrokeWidth);

        this.fillBackground = new FillBackground(props.mkey);
        this.effectFilter = new EffectFilter(props.mkey);
        this.imageFilter = new ImageFilter();
    }
}
